export default {
    DATE: 'DD.MM.YYYY',
    DATETIME: 'DD.MM.YYYY HH:mm:ss',
    DATETIME_SHORT: 'DD.MM.YYYY HH:mm',
    DATE_API: 'YYYY-MM-DDT00:00:00Z',
    DATETIME_API: 'YYYY-MM-DDTHH:mm:ssZ',
    TIME: 'HH:mm',
}


// WEBPACK FOOTER //
// ./src/dictionaries/formats.js